import React, { Component } from 'react';

import { Container } from 'components';
import ProfileForm from './ProfileForm';
import AppStore from 'AppStore';

import { withRouter } from 'react-router-dom';
import './ProfilePage.css';

class ProfilePage extends Component {
    constructor(props) {
        super(props);
        this.state = {};
        this.state.loading = AppStore.getLoadingState();
    }

    componentWillMount = () => {
        AppStore.on('loading_change', this.onLoadingChange);
        AppStore.on('profile_created', this.onProfileCreated);

        const msg =
            'You are currently using a 30 day trial version with limited functionality. To have full functionality, we invite you to sign up for our Full Registration. After a few questions and within 2 minutes you will have full access to unlimited quotes, unique options and a personalized service. There is no cost, just a few moments of your time.';
        alert(msg);
    };

    componentWillUnmount = () => {
        AppStore.removeListener('loading_change', this.onLoadingChange);
        AppStore.removeListener('profile_created', this.onProfileCreated);
    };

    onLoadingChange = () => {
        this.setState({ loading: AppStore.getLoadingState() });
    };
    onProfileCreated = () => {
        this.props.history.push('/' + this.props.match.params.nextUrl);
    };

    render() {
        console.log('MAT', this.props.match);
        return (
            <div className="profile-page page">
                <Container>
                    <ProfileForm loadingState={this.state.loading} />
                </Container>
            </div>
        );
    }
}

export default withRouter(ProfilePage);



// WEBPACK FOOTER //
// ./src/modules/profile/ProfilePage.jsx